"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLounge = function SvgLounge(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 13h3v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1zm11 0h3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.333 8.54a2.083 2.083 0 0 0 1.177-1.885l.01-.416c.102-1.166 1.064-2.08 2.235-2.08C18.995 4.16 20 5.183 20 6.447c0 1.263-1.005 2.287-2.245 2.287-.069 0-.137-.003-.204-.009v2.505c0 1.148-.914 2.08-2.04 2.08H4.49c-1.127 0-2.041-.932-2.041-2.08V8.725c-.067.006-.135.01-.204.01C1.005 8.734 0 7.71 0 6.446c0-1.264 1.005-2.288 2.245-2.288 1.17 0 2.133.914 2.236 2.08l.009.416a2.08 2.08 0 0 0 1.286 1.933M2.513 4.14C2.32 1.397 3.693.024 6.63.024h7.613c2.184.117 3.276 1.49 3.276 4.118",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 7.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 12.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 5.5,
    y: 8.5,
    width: 9,
    height: 2,
    rx: 1
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLounge);
var _default = exports["default"] = Memo;